import { create } from 'zustand'

import { currentTranslation } from '../i18n/current'

import type { ToastState } from './toast.store.types'

let seq = 0

export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],
  push: (t) => {
    const id = ++seq

    set({ toasts: [...get().toasts.slice(-3), { ...t, id }] })
    setTimeout(() => get().dismiss(id), t.kind === 'error' ? 8000 : 4000)
  },
  dismiss: (id) => set({ toasts: get().toasts.filter((t) => t.id !== id) }),
}))

export const toast = {
  success: (message: string) =>
    useToasts.getState().push({ message, kind: 'success' }),
  info: (message: string) =>
    useToasts.getState().push({ message, kind: 'info' }),
  error: (err: unknown) => {
    const e = err as { message?: string; correlationId?: string }

    useToasts.getState().push({
      message: e?.message ?? currentTranslation().t.errors.generic,
      kind: 'error',
      meta: e?.correlationId ? `Reference: ${e.correlationId}` : undefined,
    })
  },
}
